import { useState, useEffect, useRef } from 'react'
import type { UploadProps } from 'antd';
import { message, Upload, Modal, Input, Table, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table';

import { addFileRow } from '../../api/common'
import { absolute } from '@antv/x6/lib/registry/port-layout/absolute'
import { UploadOutlined, PictureOutlined, DeleteOutlined } from '@ant-design/icons';
import InitUpload from '../../components/upload';
import * as apis from '../../api/common'
import { async } from '@antv/x6/lib/registry/marker/async';
import Paging from '../pagination'

interface Props {
    onRefresh?: (id: any, file?: any) => void
    onClose?: () => void
    type?: any
    visible?: any
}

interface State {
    fileList: [],
    skip: any,
    limit: any,
    total: any,
    currentNum: any,
    search: {
        title: any,
    },
}
interface DataType {
    key: React.Key;
    name: string;
}
const { Dragger } = Upload;
const { Search } = Input;
const DocumentLibrary = (props: Props) => {
    const [state, setState] = useState<State>({
        fileList: [],
        skip: 0,
        limit: 20,
        total: 0,
        currentNum: 1,
        search: {
            title: "",
        },
    });
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [total, setTotal] = useState<any>(0);
    const [fileVisible, setFileVisible] = useState<boolean>(false);
    const [tableList, setTableList] = useState<any>([]);
    const onSearch = (value: string) => console.log(value);
    const columns: ColumnsType<DataType> = [
        {
            title: '文件',
            key: 'title',
            align: 'center',
            render: (text: any) => <span className='word-break'>
                {text?.title}</span>,
        },
        {
            title: '所属主题',
            key: 'themes',
            width: 150,
            align: 'center',
            render: (text: any) => <span>
                {text?.themes}</span>,
        },
        {
            title: '大小',
            key: 'size',
            width: 150,
            align: 'center',
            render: (text: any) => <span>
                {text?.size}</span>,
        },
        {
            title: '类型',
            key: 'mimeType',
            width: 150,
            align: 'center',
            render: (text: any) => <span>
                {text?.mimeType}</span>,
        },
        {
            title: '操作',
            key: 'id',
            width: 60,
            // dataIndex:"id",
            align: 'center',
            // render: (text: any) => <span onClick={() => { delItem(text.id) }}>
            //     1</span>,
            render: (text: any) =>
                <span>
                    <Popconfirm placement="topLeft" title={"确定删除么?"} onConfirm={() => { delItem(text) }} okText="确认" cancelText="取消">
                        <DeleteOutlined />
                    </Popconfirm></span>,

        },
    ];
    useEffect(() => {
        setFileVisible(props.visible)
        state.search.title = ''
        setState({
            ...state,
        })
    }, [props.visible])
    useEffect(() => {
        if (fileVisible) {
            getLibrary()
        } else {
        }
    }, [fileVisible])
    useEffect(() => {
        getLibrary()
    }, [state.skip])
    const getLibrary = async () => {
        let res: any = await apis.getLibrary({ $skip: state.skip * state.limit, $limit: state.limit, ...state.search });
        if (res.ok) {
            console.log('res.data.list', res.data.list)
            state.fileList = res.data.list;
            state.total = res.data.total
            setState({ ...state })
        }
    };
    const delItem = async (e: any) => {
        let res: any = await apis.deleteLibrary(e.id);
        console.log("res", res)
        if (res.ok) {
            getLibrary();
        }
    };
    const handleUpload = async (file: any) => {
        console.log(file);
        const _file = file;
        let forms = new FormData();
        // this.forms.append("name", file.name);
        forms.append("file", _file);
        forms.append("tags", '[]');

        let _api = "";
        let _params = {};
        let res: any = await apis.postLibrary(forms)
        if (res.ok) {
            state.skip = 0;
            state.search.title = "";
            setState({
                ...state,
            })
            getLibrary();
            message.success("成功");
        }
    };
    return (
        <>
            <Modal
                onCancel={() => {
                    props.onClose && props.onClose()
                }}
                forceRender
                title={<div data-flex="main:justify cross:center">
                    <div>文档库</div>
                    <Search value={state.search.title} onChange={(e) => {
                        console.log(e)
                        state.search.title = e.target.value
                        setState({
                            ...state,
                        })
                    }} className='mr-40' placeholder="请输入文件标题查询" allowClear onSearch={getLibrary} style={{ width: 200 }} />
                </div>}
                width={'1200px'}
                footer={null}
                // footer={[<Button className='btn' htmlType="submit"  key='btn' type="primary" onClick={() => {
                // }}>新建计划</Button>]}
                open={fileVisible}
            // open={true}
            >
                <div data-flex='main:justify cross:top'>
                    <div className='mr-20' style={{ flex: "auto" }}>
                        <Table
                            rowKey="id"
                            pagination={false}
                            columns={columns}
                            dataSource={state.fileList}
                            scroll={{ y: '60vh' }}
                        />
                        <Paging current={state.skip + 1} defaultPageSize={state.limit} total={state.total} onRefresh={(index: any, size: any) => {
                            console.log(index, size)
                            state.skip = index - 1;
                            setState({
                                ...state,
                            })
                        }} />
                    </div>

                    <div style={{ flex: "0 0 280px" }}>
                        <InitUpload onRefresh={(file) => {
                            handleUpload(file)
                        }} type='tuozhai' uploadText="文档"
                            accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,text/plain"
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default DocumentLibrary